function Heading({ type, children, style }) {
  switch (type) {
    case 'h1':
      return <h1 style={{ ...style }}>{children}</h1>;

    case 'h2':
      return <h2 style={{ ...style }}>{children}</h2>;

    default:
      return <h1 style={{ ...style }}>{children}</h1>;
  }
}

export default Heading;
